import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Outcomes',
      type: 'charts',
      content: {
        '{}': {
          type: 'sunburst',
          data: {
            '[]': [
              {
                '{}': {
                  root: {
                    '{}': {
                      name: 'Mission',
                      description:
                        'Give leaders the confidence to pursue their boldest visions and the clarity to pursue them wisely.',
                      children: {
                        '@': 'rootOutcomes',
                      },
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
  subqueries: {
    // TODO: how to do indefinite recursion? Maybe have something like `target:
    // 'child.recursive'` with `{ '@': '$next' }`. Or 'recursive:dim::!outcomes'
    rootOutcomes: {
      target: 'dim::!outcomes',
      filter: {
        '=': [{ '@_': 'level' }, 0],
      },
      selection: {
        '{}': {
          name: { '@.': '!name' },
          description: { '@.': '!descr' },
          children: {
            '@': 'childOutcomes',
          },
          otherInfo: {
            '[]': [
              {
                '{}': {
                  name: 'Unit',
                  value: { '@_': 'name' },
                },
              },
              {
                '{}': {
                  name: 'UnitDescription',
                  value: { '@_': 'description' },
                },
              },
            ],
          },
        },
      },
      sort: { by: { '@.': '!code' } },
      subqueries: {
        childOutcomes: {
          target: 'child',
          selection: {
            '{}': {
              name: { '@.': '!name' },
              description: { '@.': '!descr' },
              otherInfo: {
                '[]': [
                  {
                    '{}': {
                      name: 'Unit',
                      value: { '@_': 'name' },
                    },
                  },
                  {
                    '{}': {
                      name: 'UnitDescription',
                      value: { '@_': 'description' },
                    },
                  },
                  {
                    '{}': {
                      name: 'Accountable',
                      value: { '@': 'accountable' },
                    },
                  },
                  {
                    '{}': {
                      name: 'Responsible',
                      value: { '@': 'responsible' },
                    },
                  },
                  {
                    '{}': {
                      name: 'Consulted',
                      value: { '@': 'consulted' },
                    },
                  },
                  {
                    '{}': {
                      name: 'Informed',
                      value: { '@': 'informed' },
                    },
                  },
                ],
              },
            },
          },
          sort: { by: { '@.': '!code' } },
          subqueries: {
            assignees: {
              target: 'ent:!outcome_assignees:!assignee',
              ref: {
                attr: 'attr:ent#!outcome_assignees#!assignee:!outcome',
              },
              selection: {
                '{}': {
                  isAccountable: { '@.': '!is_accountable' },
                  isResponsible: { '@.': '!is_responsible' },
                  isConsulted: { '@.': '!is_consulted' },
                  isInformed: { '@.': '!is_informed' },
                },
              },
            },
            accountable: {
              using: 'assignees',
              target: 'ent:!people:!person',
              ref: {
                attr: 'attr:ent#!outcome_assignees#!assignee:!person',
              },
              filter: {
                some: [
                  { '@': 'assignees' },
                  { '@>': [{ '@$': '$value' }, 'isAccountable'] },
                ],
              },
              selection: {
                '@.': '!name',
              },
              sort: {
                by: { '@.': '!name' },
              },
            },
            responsible: {
              using: 'assignees',
              target: 'ent:!people:!person',
              ref: {
                attr: 'attr:ent#!outcome_assignees#!assignee:!person',
              },
              filter: {
                some: [
                  { '@': 'assignees' },
                  { '@>': [{ '@$': '$value' }, 'isResponsible'] },
                ],
              },
              selection: {
                '@.': '!name',
              },
              sort: {
                by: { '@.': '!name' },
              },
            },
            consulted: {
              using: 'assignees',
              target: 'ent:!people:!person',
              ref: {
                attr: 'attr:ent#!outcome_assignees#!assignee:!person',
              },
              filter: {
                some: [
                  { '@': 'assignees' },
                  { '@>': [{ '@$': '$value' }, 'isConsulted'] },
                ],
              },
              selection: {
                '@.': '!name',
              },
              sort: {
                by: { '@.': '!name' },
              },
            },
            informed: {
              using: 'assignees',
              target: 'ent:!people:!person',
              ref: {
                attr: 'attr:ent#!outcome_assignees#!assignee:!person',
              },
              filter: {
                some: [
                  { '@': 'assignees' },
                  { '@>': [{ '@$': '$value' }, 'isInformed'] },
                ],
              },
              selection: {
                '@.': '!name',
              },
              sort: {
                by: { '@.': '!name' },
              },
            },
          },
        },
      },
    },
  },
}
